import { all } from 'redux-saga/effects';

import activities from './activities/sagas';
import cep from './cep/sagas';
import comments from './comments/sagas';
import dataList from './dataList/sagas';
import dynamicTable from './dynamicTable/sagas';
import importProcesses from './importProcesses/sagas';
import processes from './processes/sagas';
import reports from './reports/sagas';
import tasks from './tasks/sagas';
import users from './users/sagas';

export default function* rootSaga(): any {
  return yield all([
    activities,
    cep,
    comments,
    dataList,
    dynamicTable,
    importProcesses,
    processes,
    reports,
    tasks,
    users,
  ]);
}
